// @flow

import './DesktopHeader.scss';

import { noop } from '@boi/core/lib/utils';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Node } from 'react';
import React, { Children } from 'react';
import { Link } from 'react-router-dom';

import { withPrefix } from '../../helpers';

type Props = {
  link?: string,
  text: string,
  children?: Node,
  index: string,
  underline: boolean,
  disabled?: boolean,
  selectedMenu?: ?string,
  setSelectedMenu: (?string) => noop,
  onClick?: () => void
};

const withClass = withPrefix('c-SubHeading');

export const SubHeadingMenu = ({
  index,
  link = '',
  text,
  onClick,
  children,
  selectedMenu,
  setSelectedMenu,
  underline = false,
  disabled = false
}: Props) => {
  const numItems = Children.count(children);
  const isDropDown = numItems > 0;

  const wrapperSuffix = () =>
    isDropDown
      ? underline
        ? '__dropdownRowUnderLink'
        : '__dropdownRow'
      : '__anchorLink';

  const singleLinkSuffix = () => (underline ? '__underLineLink' : '__link');

  const isDisabled = () => disabled || undefined;

  const isExpanded = () => selectedMenu === index;

  const expandButton = () => (
    <div className={withClass('__paddingCheveron')}>
      <FontAwesomeIcon
        icon={faChevronDown}
        className={withClass('__buttonIcon')}
        alt={isExpanded() ? 'Collapse' : 'Expand'}
      />
    </div>
  );

  return (
    <div
      key={`desktop-menu-item-${index}`}
      className={withClass(wrapperSuffix())}
      onClick={() => {
        setSelectedMenu(index);
        onClick && onClick();
      }}
      onKeyDown={() => setSelectedMenu(index)}
      tabIndex={isDropDown ? 0 : undefined}
    >
      {isDropDown ? (
        <>
          <div className={withClass('__link')} key={index}>
            {text}
          </div>
          {expandButton()}
          {isExpanded() && (
            <div className={withClass('__dropdownMenu')}>{children}</div>
          )}
        </>
      ) : (
        <Link
          to={link}
          key={index}
          className={withClass(singleLinkSuffix())}
          onClick={onClick}
          disabled={isDisabled()}
        >
          {text}
        </Link>
      )}
    </div>
  );
};
